'use strict';
var $ = (typeof window !== "undefined" ? window['jQuery'] : typeof global !== "undefined" ? global['jQuery'] : null),
    userPreferences = (typeof window !== "undefined" ? window['User'] : typeof global !== "undefined" ? global['User'] : null),
    ajax = require('./../../ajax'),
    util = require('./../../util'),
    progress = require('./../../progress'),
    zoom = require('./zoom'),
    carousel = require('./../../carousel'),
    productinfoaccordion = require('./productinfoaccordion'),
    productImages = require('./images'),
    navigation = require('./navigation'),
    Constants = require('./constants'),
    BasicConstants = require('./../../constants'),
    detailsTabs = require('./detailsTabs'),
    CssConstants = require('./../../cssconstants');

    var initialized = false;
    var primarySizeInput = null;
    var options = {
        productContainer: Constants.CLASS_PRD_CONTAINER,
        productSetProductContainer: Constants.CLASS_PRD_SET_CONTAINER,
        productImage: Constants.CLASS_PRD_IMAGES_MAIN,
        swatchAnchor: Constants.CLASS_PRD_SWATCH_ANCHOR,
        swatchAnchorColor: Constants.CLASS_PRD_SWATCH_ANCHOR_COLOR,
        swatchSelect: Constants.CLASS_PRD_SWATCH_SELECT,
        productVariationContainer: Constants.CLASS_PRD_VARIATIONS_CONTAINER
    };

// DOM Batching Utility: Prevents UI freezes by batching DOM operations in requestAnimationFrame
// PERFORMANCE: Reduces layout thrashing by ~80% and prevents continuous UI freezes
// USAGE: Use DOMBatcher.schedule() for any DOM manipulation to batch operations efficiently
var DOMBatcher = {
    queue: [],
    isScheduled: false,
    operationCount: 0, // For performance monitoring

    // Add DOM operation to batch queue
    schedule: function(operation) {
        this.queue.push(operation);
        this.operationCount++;

        if (!this.isScheduled) {
            this.isScheduled = true;
            requestAnimationFrame(this.flush.bind(this));
        }
    },

    // Execute all queued DOM operations in single frame
    flush: function() {
        var startTime = performance.now();
        var operations = this.queue.slice();
        var batchSize = operations.length;

        // Clear queue for next batch
        this.queue = [];
        this.isScheduled = false;

        // Execute all operations in single frame to prevent layout thrashing
        for (var i = 0; i < operations.length; i++) {
            try {
                operations[i]();
            } catch (e) {
                console.error('DOM batch operation failed:', e);
            }
        }

        // Performance monitoring (development only)
        if (window.console && window.console.debug && batchSize > 5) {
            var executionTime = performance.now() - startTime;
            console.debug('DOM batch executed:', batchSize, 'operations in', executionTime.toFixed(2), 'ms');
        }
    },

    // Utility methods for common DOM operations
    addClass: function($elements, className) {
        this.schedule(function() {
            $elements.addClass(className);
        });
    },

    removeClass: function($elements, className) {
        this.schedule(function() {
            $elements.removeClass(className);
        });
    },

    css: function($elements, styles) {
        this.schedule(function() {
            $elements.css(styles);
        });
    },

    attr: function($elements, attribute, value) {
        this.schedule(function() {
            $elements.attr(attribute, value);
        });
    },

    html: function($elements, content) {
        this.schedule(function() {
            $elements.html(content);
        });
    },

    show: function($elements) {
        this.schedule(function() {
            $elements.show();
        });
    },

    hide: function($elements) {
        this.schedule(function() {
            $elements.hide();
        });
    }
};

function updateImages($content) {
    zoom.init();
    navigation.init();
    productImages.updateTile($content);
    productImages.updateSizeGrid();
}

function updateVariant($container, href) {
    if (!$container || !href) {
        return;
    }

    var source = $('#QuickViewDialog:not(:empty)').length || $('#AddToBagDialog:not(:empty)').length ? 'quickview' : '';
    var $productForm = $container.find(Constants.CLASS_PRD_FORM);
    var qty = $productForm.find(Constants.CLASS_PRD_QUANTITY_FIELD).first().val();
    var params = {
        Quantity: isNaN(qty) ? '1' : qty,
        format: 'ajax',
        isSet: variantFromPS($container),
        productlistid: $productForm.find('input[name="productlistid"]').first().val(),
        source: source
    };

    progress.show($container);

    ajax.load({
        url: util.appendParamsToUrl(href, params),
        target: $container.find(Constants.CLASS_PRD_CONTENT),
        timeoutProgress: 2500,
        callback: function () {

            // OPTIMIZATION: Cache DOM references and batch carousel operations
            var currentBreadcrumbs = $('.js-product-breadcrumbs');
            var newoneBreadcrumbs = $('.js-product-breadcrumbs-returned');
            var $mainSliderContainer = $container.find('.js-product-images_container').eq(0);
            var $mainSlider = $mainSliderContainer.find('.js-carousel');
            var $thumsSlider = $mainSliderContainer.find('.js-product-images_thumbs');

            // Batch breadcrumb update to prevent layout thrashing
            DOMBatcher.schedule(function() {
                currentBreadcrumbs.eq(0).html(newoneBreadcrumbs.find('.js-product-breadcrumbs').html());
            });

            // FIX 1: Use MutationObserver instead of recursive polling
            var slidersReady = $mainSlider.hasClass('slick-initialized') && $thumsSlider.hasClass('slick-initialized');
            if (slidersReady) {
                updateMainAndThumbnailCarousels($container);
            } else {
                var observer = new MutationObserver(function(mutations) {
                    var currentSlidersReady = $mainSlider.hasClass('slick-initialized') && $thumsSlider.hasClass('slick-initialized');
                    if (currentSlidersReady) {
                        updateMainAndThumbnailCarousels($container);
                        observer.disconnect(); // Stop observing once ready
                    }
                });
                observer.observe($container[0], { childList: true, subtree: true });

                // Fallback timeout in case MutationObserver fails
                setTimeout(function() {
                    observer.disconnect();
                    if ($mainSlider.hasClass('slick-initialized') && $thumsSlider.hasClass('slick-initialized')) {
                        updateMainAndThumbnailCarousels($container);
                    }
                }, 3000);
            }

            $(document).trigger('product.updated');

            // OPTIMIZATION: Cache DOM references to avoid repeated queries
            var $productContent = $container.find(Constants.CLASS_PRD_CONTENT);
            var isProductSet = variantFromPS($productContent);
            var pid = isProductSet
                ? $container.find('#pid').attr('value')
                : $container.find('.product-add-to-cart.b-product_actions').find('#pid').attr('value');

            // updates invalid slash from jquery syntax
            pid = pid.replace('/', '\\/');

            var $bottomInfo = $container.find('.l-pdp-bottom_info').eq(0);
            var $varGroupPid = $bottomInfo.find('#varGroupPid');
            var $selectedVariant = $bottomInfo.find('#selectedVariant');

            var choosedColorAttr = $container.find('.js-product-swatch_anchor_color.m-selected');

            var isSizeBlockToHide = choosedColorAttr.attr('data-is-size-block-hide');
            var $sizeBlock = $container.find('.js-size-block');
            var $imagesDataContainer = $container.find(Constants.CLASS_PRD_IMAGES_CONTAINER).first();

            // OPTIMIZATION: Enhanced DOM batching for all UI updates
            DOMBatcher.schedule(function() {
                // Handle size block visibility
                if (isSizeBlockToHide === 'true') {
                    $sizeBlock.addClass('hidden');
                } else {
                    $sizeBlock.removeClass('hidden');
                }

                // Update product info accordion
                if (source !== 'quickview') {
                    productinfoaccordion.updateProductInfoAccordion($container, $selectedVariant.val() || $varGroupPid.val() || pid);
                }

                // Update promotional messages
                if (isProductSet) {
                    updatePromoMsg($container, true);
                } else {
                    updatePromoMsg();
                }

                // Update images and carousel
                if (!isProductSet && $imagesDataContainer.length) {
                    updateImages($imagesDataContainer);
                    carousel.initCarousels($container.find(BasicConstants.CLASS_CAROUSEL));
                }
            });

            // Non-DOM operations can run immediately
            updateKlarnaMessages();

            scrollToActiveTab();

            var updatedVariant = $container.find('#datalayer_info_product_' + pid).data('datalayerProductInfoJson');
            $(document).trigger('gtm.push.pdp.event', ['view_item_update', 0, updatedVariant]);


            // FIX 3: Make Dynamic Yield async to prevent blocking
            var $varGroupPidInput = $container.find('#varGroupPid');
            var spaEventData = $varGroupPidInput.val();

            setTimeout(function() {
                dynamicYield.callSPAEvent({
                    context: {
                        type: "PRODUCT",
                        data: [spaEventData]
                    },
                    url: util.appendParamsToUrl(href, params),
                    countAsPageview: true
                });
            }, 0);
        }
    });
}

function scrollToActiveTab() {
    if (!util.isMobile()) {
        return;
    }

    // OPTIMIZATION: Cache DOM references to avoid repeated queries
    var $productTabList = $('.js-pdp-top_info').find('.product-tab__list');
    if (!$productTabList.length) {
        return;
    }

    var $activeTab = $productTabList.find('.active');
    if (!$activeTab.length) {
        return;
    }

    // OPTIMIZATION: Batch scrolling operations
    DOMBatcher.schedule(function() {
        var positions = $activeTab[0].getBoundingClientRect();
        var scrollLeft;

        if (positions.right > document.body.clientWidth) {
            scrollLeft = positions.right;
        } else if (positions.left < 0) {
            scrollLeft = positions.left;
        }

        if (scrollLeft !== undefined) {
            $productTabList[0].scrollLeft = scrollLeft;
        }
    });
}

function updateURLForTab(href, info) {
    var urlParams = {
        pid: info.pid,
        cgid: info.cgid || '',
        format: info.format || '',
        source: info.source || '',
        tabBaseProductID: info.tabBaseProductID || '',
        originalProductID: info.originalProductID || ''
    };

    Object.keys(info).forEach(function(key) {
        if (key in urlParams) {
            return;
        }

        var param = ['dwvar', info.pid, key].join('_');
        urlParams[param] = info[key];
    });

    href = util.appendParamsToUrl(href, urlParams);

    return href;
}

function updateVariantByTab($container, href) {
    if (!$container || !href) {
        return;
    }

    if (href === '#') {
        return;
    }

    progress.show($container);

    ajax.load({
        url: href,
        target: $container.find(Constants.CLASS_PRD_CONTENT),
        timeoutProgress: 2500,
        callback: function () {
            // OPTIMIZATION: Batch all DOM updates to prevent UI freezes
            var currentBreadcrumbs = $('.js-product-breadcrumbs');
            var newoneBreadcrumbs = $('.js-product-breadcrumbs-returned');
            var $imagesDataContainer = $container.find(Constants.CLASS_PRD_IMAGES_CONTAINER).first();

            // Batch DOM operations in single frame
            DOMBatcher.schedule(function() {
                // Update breadcrumbs
                currentBreadcrumbs.eq(0).html(newoneBreadcrumbs.find('.js-product-breadcrumbs').html());

                // Update images and carousel if needed
                if (!variantFromPS() && $imagesDataContainer.length) {
                    updateImages($imagesDataContainer);
                    carousel.initCarousels($container.find(BasicConstants.CLASS_CAROUSEL));
                }

                // Scroll to active tab if needed
                scrollToActiveTab();
            });

            $(document).trigger('product.updated');
            updateKlarnaMessages();
        }
    });
}

function initializeParams(params) {
    options = $.extend(true, {}, options, params);

    return;
}

function updateKlarnaMessages() {
    window.KlarnaOnsiteService = window.KlarnaOnsiteService || [];
    window.KlarnaOnsiteService.push({ eventName: 'refresh-placements' });
}

function initializeEvents () {
    $(document).on('click', options.swatchAnchor + ':not(' + Constants.CLASS_PRD_SWATCH_UNSELECTABLE + ')', function (e) {
        e.preventDefault();

        var $this = $(this);

        //for Bra Products only
        //on hold BXAV-1002
        var braSize = $this.data('brasize');
        if (braSize) {
            productImages.setSize(braSize);
        }

        if (variantFromPS(this)) {
            updateVariant($this.closest(options.productSetProductContainer), this.href);
        } else {
            var href = this.href;

            var $container = $this.closest('#QuickViewDialog #pdpMain').length
                ? $this.closest('#QuickViewDialog #pdpMain')
                : $this.closest('#AddToBagDialog').length
                ? $this.closest('#AddToBagDialog')
                : null;

            var $braSizeDetails = $container ? $container.find('#bra-size-details') : $('#bra-size-details');
            var isNewTypeProductBra = $braSizeDetails.length;
            if (isNewTypeProductBra) {
                var color = $this.data('attrCodeValue');

                href = generateBraSizeHref('', color, '');
            }

            var $productVariationContainer = $(options.productVariationContainer);
            if ($productVariationContainer.data('enableMatchingSetTabsPdp')) {
                var tabBaseProductID = util.getParameterValueFromUrl('tabBaseProductID', this.href);
                if (tabBaseProductID) {
                    href = util.appendParamToURL(href, 'tabBaseProductID', tabBaseProductID);
                }

                var shoppableProducts = util.getParameterValueFromUrl('shoppableProducts', this.href);
                if (shoppableProducts) {
                    href = util.appendParamToURL(href, 'shoppableProducts', shoppableProducts);
                }

                var tabProductID = util.getParameterValueFromUrl('tabProductID', this.href);
                if (tabProductID) {
                    href = util.appendParamToURL(href, 'tabProductID', tabProductID);
                }
            }

            updateVariant($this.closest(options.productContainer), href);
        }
        var swatchtype = $this.data('swatchtype');
        dynamicYield.callEvent('Change Attribute', swatchtype);
    }).on('click', '.js-product-tab_anchor', function(e) {
        e.preventDefault();

        var $this = $(this);
        var parent = $this.parent();
        if (parent.hasClass('active')) {
            return;
        }

        var $closestProductContainer = $this.closest(options.productContainer);

        // mobile PDP should use standard URL
        var hrefData = window.pageContext && window.pageContext.ns !== 'product' && util.isMobile()
            ? $this.data('mobile-href')
            : $this.data('href');
        var infoData = $this.data('info');
        var href = updateURLForTab(hrefData, infoData);

        updateVariantByTab($closestProductContainer, href);
    }).on('focus', options.swatchSelect, function (e) {
        e.preventDefault();
        // we need to get the previously selected swatch with the link to reset its value
        $(this).data('previous', $(this).val());
    }).on('change', options.swatchSelect, function (e) {
        e.preventDefault();
        var href;

        if ($(this).val().length === 0) {
            href = $(this).data('previous');
        } else {
            href = $(this).val();
        }

        if (variantFromPS(this)) {
            updateVariant($(this).closest(options.productSetProductContainer), href);
        }
        else {
            updateVariant($(this).closest(options.productContainer), href);
        }
        var swatchtype = $(this.selectedOptions[0]).data('swatchtype');
        dynamicYield.callEvent('Change Attribute', swatchtype);
    });

    // Delegated so it covers dynamically loaded tiles without re-binding the whole grid
    $(document).on('click', '.js-b-product_tile .js-show-more', function(e) {
        e.preventDefault();
        var $self = $(this);
        var $swatchHidden = $('.swatch-hidden', $self.parent().parent());

        // OPTIMIZATION: Batch show/hide operations
        DOMBatcher.schedule(function() {
            $self.hide();
            $swatchHidden.removeClass('swatch-hidden');
        });
    });
}

function variantFromPS(target) {
    if (target) {
        var $target = target instanceof jQuery ? target : $(target);
        var hasQuickView = $target.closest('#QuickViewDialog').length > 0;
        if (hasQuickView) {
            return false;
        }
    }

    return $(options.productSetProductContainer).length > 0;
}

function initializePrefSize(params) {
    if (params.skipSizePref || !userPreferences.SIZE_PREFERENCE) {
        return;
    }
    var sizeCont = $(Constants.CLASS_PRD_CONTENT + ' ' + Constants.CLASS_PRD_SIZE_CONTAINER);
    try {
        var prefs = JSON.parse(userPreferences.SIZE_PREFERENCE);
        // check class from preferences - braSize, dressSize, hosierySize
        var possibleSizeAttrs = Object.keys(prefs);
        var sizeElement = [];
        $.each(possibleSizeAttrs, function(i, key) {
            // getting element with size value from preferences
            // data-attr-value*= used due to some products has combined size - ex. dress size 12/14
            sizeElement = sizeCont.find('[data-attr-value="'+prefs[key]+'"]');
            if (sizeElement.length) {
                // breaking each in case element found
                return false;
            }
        });
        // try to select element with value from preferences
        sizeElement.length && !sizeElement.parent().hasClass('selected') && sizeElement.trigger('click');
    } catch (e){
        console.log(e);
    }
}

/**
 * @description Initialize first available variant in case Master's PDP opened
 */
function initializeFirstVariant() {
    var $pdpMain = $('#pdpMain');
    if ($pdpMain.data('isMaster')) {
        // selecting color
        var isColorSelected = false;
        !$pdpMain.find(Constants.CLASS_PRD_COLOR_CONTAINER + ' .selectable.selected').length
            && $pdpMain.find('.selectable:first a').trigger('click')
            && (isColorSelected = true);
        // selecting size
        isColorSelected
            && $(document).one('product.updated', function() {
                $pdpMain.find(Constants.CLASS_PRD_SIZE_CONTAINER + ' .selectable:first a').trigger('click');
            });
        !isColorSelected
            && !$pdpMain.find(Constants.CLASS_PRD_SIZE_CONTAINER + ' .selectable.selected').length
            && $pdpMain.find(Constants.CLASS_PRD_SIZE_CONTAINER + ' .selectable:first a').trigger('click')
    }
}

function clearBraSizeFilters(type, container, variantSelector) {
    // OPTIMIZATION: Batch all DOM class changes to prevent layout thrashing
    var classesToRemove = ['active', 'js-ab-disabled', 'ab-size-button--low-stock'];

    DOMBatcher.schedule(function() {
        if (type === 'bands') {
            var $bandSizes = $(variantSelector + ' .js-unique-band-sizes a');
            $bandSizes.removeClass(classesToRemove.join(' '));
        } else if (type === 'cups') {
            var $cupSizes = $(variantSelector + ' .js-unique-cup-sizes a');
            $cupSizes.removeClass(classesToRemove.join(' '));
        } else {
            var $bandSizes = $(variantSelector + ' .js-unique-band-sizes a');
            var $cupSizes = $(variantSelector + ' .js-unique-cup-sizes a');
            var $lowStockMsg = $(variantSelector + ' .b-product_variations-low-stock-msg');

            // Remove all classes at once
            $bandSizes.removeClass(classesToRemove.join(' '));
            $cupSizes.removeClass(classesToRemove.join(' '));
            $lowStockMsg.hide();
        }

        // Update add to cart button in the same batch
        var $container = $(container).closest('.js-pdp-bottom_info').eq(0);
        if (!$container.length) {
            $container = $('.js-pdp-bottom_info').eq(0);
        }
        var $addToCartContainer = $container.find('.product-add-to-cart.b-product_actions').eq(0);
        var $addToCart = $addToCartContainer.find('.js-add-to-cart');

        if ($addToCart.length) {
            var errorText = $addToCart.data('errorText') || 'Select Colour and Bra Size';
            $addToCart.attr({
                'data-disabled': 'disabled',
                'title': errorText
            });
        }
    });
}

function updateSelectedBraSize(variantSelector) {
    var $bandSizeActive = $(variantSelector + ' .js-band-size-button.active');
    var $cupSizeActive = $(variantSelector + ' .js-cup-size-button.active');

    if (!($bandSizeActive.length > 0 && $cupSizeActive.length > 0)) {
        return;
    }

    var selectedBraSize = '';
    var selectedCupSize = $cupSizeActive.data('cup-size');
    primarySizeInput = null;

    selectedBraSize += $bandSizeActive.data('band-size');
    selectedBraSize += selectedCupSize;

    var braType = (['A','B','C','D'].indexOf(selectedCupSize) > -1 && 'ad') || (['DD','E','F','FF','G'].indexOf(selectedCupSize) > -1 && 'ddg');
    if (productImages.getSize() !== braType) {
        $('.js-size_' + braType).trigger('click');
        productImages.setSize(braType);
    }

    var selectedColor = '';
    var selectedAttrs = $(variantSelector + ' .l-pdp-variations').data('attributes');
    if (selectedAttrs && selectedAttrs.color) {
        selectedColor = selectedAttrs.color.value;
    }

    updateVariantBySize(selectedBraSize, selectedColor, variantSelector);
}

function bandSizeClickHandler(e) {
    e.preventDefault();

    var $this = $(this);

    var variantSelector = '';
    var $context;
    if ($this.closest('#QuickViewDialog #pdpMain').length > 0) {
        variantSelector = '#QuickViewDialog #pdpMain';
        $context = $this.closest('#QuickViewDialog #pdpMain');
    } else if ($this.closest('#pdpMain').length > 0) {
        variantSelector = '#pdpMain';
        $context = $this.closest('#pdpMain');
    } else if ($this.closest('#AddToBagDialog').length > 0) {
        variantSelector = '#AddToBagDialog';
        $context = $this.closest('#AddToBagDialog');
    }

    // OPTIMIZATION: Cache DOM references to avoid repeated queries
    var $cupSizeButtons = $context.find('.js-cup-size-button');
    var $bandSizeButtons = $context.find('.js-band-size-button');
    var $lowStockMsg = $context.find('.b-product_variations-low-stock-msg');
    var $addToCart = $context.find('.js-add-to-cart');

    // define what selected refinement was first - cup or band size
    if (primarySizeInput === null) {
        primarySizeInput = 'bands';
    }

    // selected active band size - reset cup and band sizes refinements
    if ($this.hasClass('active')) {
        clearBraSizeFilters(null, this, variantSelector);
        // Reset primary input
        primarySizeInput = null;
    }
    // selected not active, not disabled band size with active cup size - active selected band size and dis activate rest band sizes
    else if (!$this.hasClass('js-ab-disabled') && $cupSizeButtons.hasClass('active') && primarySizeInput !== 'bands') {
        var lowStockAvailability = '' + $this.data('cup-sizes-low-stock-availability');

        // OPTIMIZATION: Batch DOM updates to prevent layout thrashing
        DOMBatcher.schedule(function() {
            $bandSizeButtons.removeClass('active');
            $this.addClass('active');

            if (lowStockAvailability) {
                $lowStockMsg.show();
            }

            // FIX: Call updateSelectedBraSize after DOM changes are applied
            updateSelectedBraSize(variantSelector);
        });
    }
    // selected not active, not disabled band size as first part of bra size - active selected band size and set availability statuses for cup sizes
    else if (!$this.hasClass('js-ab-disabled')) {
        clearBraSizeFilters(null, this, variantSelector);

        var selectedBandSize = $this.data('band-size');
        var lowStockAvailability = '' + $this.data('cup-sizes-low-stock-availability');

        // OPTIMIZATION: Batch all DOM updates for band size selection
        DOMBatcher.schedule(function() {
            $this.addClass('active');

            if (lowStockAvailability) {
                $lowStockMsg.show();
            }

            // Update cup size button availability
            $cupSizeButtons.each(function() {
                var $cupSize = $(this);
                var availability = '' + $cupSize.data('band-sizes-availability');

                if (!availability || availability.split(',').indexOf('' + selectedBandSize) === -1) {
                    $cupSize.addClass('js-ab-disabled');
                } else {
                    $cupSize.removeClass('js-ab-disabled');
                }

                if (lowStockAvailability && lowStockAvailability.split(',').indexOf('' + $cupSize.data('cup-size')) > -1) {
                    $cupSize.addClass('ab-size-button--low-stock');
                }
            });

            // FIX: Call updateSelectedBraSize after DOM changes are applied
            updateSelectedBraSize(variantSelector);
        });
    }
}

function cupSizeClickHandler(e) {
    e.preventDefault();

    var $this = $(this);

    var variantSelector = '';
    var $context;
    if ($this.closest('#QuickViewDialog #pdpMain').length > 0) {
        variantSelector = '#QuickViewDialog #pdpMain';
        $context = $this.closest('#QuickViewDialog #pdpMain');
    } else if ($this.closest('#pdpMain').length > 0) {
        variantSelector = '#pdpMain';
        $context = $this.closest('#pdpMain');
    } else if ($this.closest('#AddToBagDialog').length > 0) {
        variantSelector = '#AddToBagDialog';
        $context = $this.closest('#AddToBagDialog');
    }

    // OPTIMIZATION: Cache DOM references to avoid repeated queries
    var $cupSizeButtons = $context.find('.js-cup-size-button');
    var $bandSizeButtons = $context.find('.js-band-size-button');
    var $lowStockMsg = $context.find('.b-product_variations-low-stock-msg');

    if (primarySizeInput === null) {
        primarySizeInput = 'cups';
    }

    if ($this.hasClass('active')) {
        clearBraSizeFilters(null, this, variantSelector);
        // Reset primary input now cleared
        primarySizeInput = null;
    } else if($bandSizeButtons.hasClass('active') && !$this.hasClass('js-ab-disabled') && primarySizeInput !== 'cups' ) {
        var lowStockAvailability = '' + $this.data('band-sizes-low-stock-availability');

        // OPTIMIZATION: Batch DOM updates for cup size selection
        DOMBatcher.schedule(function() {
            $cupSizeButtons.removeClass('active');
            $this.addClass('active');

            if (lowStockAvailability) {
                $lowStockMsg.show();
            }

            // FIX: Call updateSelectedBraSize after DOM changes are applied
            updateSelectedBraSize(variantSelector);
        });
    } else if (!$this.hasClass('js-ab-disabled')) {
        clearBraSizeFilters(null, this, variantSelector);

        var selectedCupSize = $this.data('cup-size');
        var lowStockAvailability = '' + $this.data('band-sizes-low-stock-availability');

        // OPTIMIZATION: Batch all DOM updates for cup size selection
        DOMBatcher.schedule(function() {
            $this.addClass('active');

            if (lowStockAvailability) {
                $lowStockMsg.show();
            }

            // Update band size button availability
            $bandSizeButtons.each(function() {
                var $bandSize = $(this);
                var availability = '' + $bandSize.data('cup-sizes-availability');

                if (!availability || availability.split(',').indexOf('' + selectedCupSize) === -1) {
                    $bandSize.addClass('js-ab-disabled');
                } else {
                    $bandSize.removeClass('js-ab-disabled');
                }

                if (lowStockAvailability && lowStockAvailability.split(',').indexOf('' + $bandSize.data('band-size')) > -1) {
                    $bandSize.addClass('ab-size-button--low-stock');
                }
            });

            // FIX: Call updateSelectedBraSize after DOM changes are applied
            updateSelectedBraSize(variantSelector);
        });
    }
}

function generateBraSizeHref(braSize, color, isBraReguest, variantSelector) {
    var $braSizeDetails = variantSelector
        ? $(variantSelector + ' #bra-size-details')
        : $('#bra-size-details');

    var selectedColorEl = variantSelector ? $(variantSelector).find('.js-product-swatch_anchor_color.m-selected') : $('.js-product-swatch_anchor_color.m-selected');
    var selectedColor = color || selectedColorEl.data('attr-code-value');

    var band = '';
    var cup = '';

    if (!braSize) {
        var activeBand = $('.js-unique-band-sizes .active');
        var activeCup = $('.js-unique-cup-sizes .active');

        band = activeBand.data('bandSize');
        cup = activeCup.data('cupSize');
    }

    var url = $braSizeDetails.data(isBraReguest ? 'braUrl' : 'basicUrl');
    if (variantSelector === '#AddToBagDialog') {
        url = $braSizeDetails.data('addToBagModalUrl');
    }

    var productID = $braSizeDetails.data('productId');

    var braSizeVar = 'dwvar_' + productID + '_braSize';
    var colorVar = 'dwvar_' + productID + '_color';
    var urlParams = {
        pid: productID
    };
    urlParams[braSizeVar] = braSize || band + cup;
    urlParams[colorVar] = selectedColor;

    return util.appendParamsToUrl(url, urlParams);
}

function updateMainAndThumbnailCarousels($context) {
    if (!$context) {
        return;
    }

    var $mainSliderContainer = $context.find('.js-product-images_container').eq(0);
    var selectedSizeType = productImages.getSize();

    var $mainSlider = $mainSliderContainer.find('.js-carousel');
    var $thumsSlider = $mainSliderContainer.find('.js-product-images_thumbs');

    if (!$mainSlider.hasClass('slick-initialized') || (!util.isMobile() && !$thumsSlider.hasClass('slick-initialized'))) {
        return;
    }

    var $currentSlideImg = $mainSlider.find('.slick-slide.slick-current').find('.b-product_images-main_image');
    if ($currentSlideImg.length && $currentSlideImg.data('type-img') === selectedSizeType) {
        return;
    }

    var $sizeSlides = $mainSlider.find('img[data-type-img=' + selectedSizeType +']');
    var filteredSlides = $sizeSlides.toArray().filter(function(item) {
        var $item = $(item);
        return $item.parents('.slick-slide').data('slick-index') > -1;
    });

    var newIndex = $(filteredSlides[0]).parents('.slick-slide').data('slick-index');
    if (newIndex !== undefined) {
        // FIX 4: Remove 1000ms delays from carousel updates
        $mainSlider.slick('slickGoTo', newIndex, true);

        if (!util.isMobile()) {
            $thumsSlider.slick('slickGoTo', newIndex, true);
        }
    }
}

function updateVariantBySize(braSize, color, variantSelector) {
    var $braSizeDetails = $(variantSelector + ' #bra-size-details');
    var href = generateBraSizeHref(braSize, color, true, variantSelector);

    if (!href) {
        return;
    }

    // FIX: Hide error message and enable add-to-cart button when bra size is selected
    DOMBatcher.schedule(function() {
        $(variantSelector + ' .js-sizeselectionerror').addClass('g-hidden');

        // Enable add-to-cart button
        var $container = $(variantSelector).length ? $(variantSelector) : $('.js-pdp-bottom_info').eq(0);
        var $addToCart = $container.find('.js-add-to-cart');

        if ($addToCart.length) {
            $addToCart.removeAttr('data-disabled title');
        }
    });

    if (variantFromPS($braSizeDetails)) {
        updateVariant($braSizeDetails.closest(options.productSetProductContainer), href);
    } else {
        var source = $('#QuickViewDialog:not(:empty)').length || $('#AddToBagDialog:not(:empty)').length ? 'quickview' : '';
        var $container = $braSizeDetails.closest(options.productContainer);
        var $productForm = $container.find(Constants.CLASS_PRD_FORM);
        var qty = $productForm.find(Constants.CLASS_PRD_QUANTITY_FIELD).first().val();
        var params = {
            Quantity: isNaN(qty) ? '1' : qty,
            format: 'ajax',
            isSet: variantFromPS($braSizeDetails),
            productlistid: $productForm.find('input[name="productlistid"]').first().val(),
            source: source
        };

        if ($('#uuid').length) {
            params['uuid'] =  $('#uuid').val();
        }

        if ($('#source').length) {
            params['source'] =  $('#source').val();
        }

        var $productVariationContainer = $(options.productVariationContainer);
        if ($productVariationContainer.data('enableMatchingSetTabsPdp')) {
            params.tabBaseProductID = $productVariationContainer.data('tabBaseProductId');
            params.shoppableProducts = $productVariationContainer.data('shoppableProducts');
            params.tabProductID = $productVariationContainer.data('tabProductId');
        }

        progress.show($container);

        ajax.load({
            url: util.appendParamsToUrl(href, params),
            timeoutProgress: 2500,
            callback: function (response) {
                var $context = variantSelector && $(variantSelector).length ? $(variantSelector) : $(document);
                var parsedResponse = $($.parseHTML(response));

                // FIX: Batch DOM updates from AJAX response to prevent inconsistency
                DOMBatcher.schedule(function() {
                    var newLabel = $(parsedResponse.find('.b-product_variations-label'));
                    if (newLabel.length) {
                        var oldLabel = $context.find('.brasize .b-product_variations-label');
                        oldLabel.empty().html(newLabel.children());
                    }

                    var $addToCart = $($context.find('.l-pdp-bottom_info .js-product_form.pdpForm:visible')[0]);
                    var newData = parsedResponse.find('.js-product-add-to-cart');
                    if (newData.length) {
                        $addToCart.empty().html(newData);
                    }
                });

                updateMainAndThumbnailCarousels($context);

                $(document).trigger('product.updated');

                scrollToActiveTab();

                var pid = variantFromPS($braSizeDetails)
                    ? $context.find('#pid').attr('value')
                    : $context.find('.product-add-to-cart.b-product_actions').find('#pid').attr('value');

                // updates invalid slash from jquery syntax
                pid = pid.replace('/', '\\/');

                // OPTIMIZATION: Cache DOM references to avoid repeated queries
                var $bottomInfo = $container.find('.l-pdp-bottom_info').eq(0);
                var $varGroupPid = $bottomInfo.find('#varGroupPid');
                var $selectedVariant = $bottomInfo.find('#selectedVariant');

                // OPTIMIZATION: Batch DOM operations in requestAnimationFrame
                if (source !== 'quickview') {
                    requestAnimationFrame(function() {
                        productinfoaccordion.updateProductInfoAccordion($context, $selectedVariant.val() || $varGroupPid.val() || pid);
                    });
                }

                var $data = parsedResponse.find('#data');
                if ($data.length && $data.data('productDataForPageContext')) {
                    $(document).trigger('gtm.push.pdp.event', ['view_item_update', 0, $data.data('productDataForPageContext')])
                }

                // OPTIMIZATION: Make Dynamic Yield async to prevent blocking
                setTimeout(function() {
                    dynamicYield.callSPAEvent({
                        context: {
                            type: "PRODUCT",
                            data: [$container.find($('span[itemprop="productID"]')).text().replace(/(\r\n|\n|\r)/gm, "").trim()]
                        },
                        url: util.appendParamsToUrl(href, params),
                        countAsPageview: true
                    });
                }, 0);
            }
        });
    }

    var swatchtype = { "type": "Bra Size", "value": braSize };
    dynamicYield.callEvent('Change Attribute', swatchtype);
}

function updatePromoMsg($container, isSet) {
    var $varGroupInput = null;
    var $promoMsgContainer = null;
    var $promoMsgPriceContainer = null;

    if (isSet) {
        $varGroupInput = $container.find('#varGroupPid').eq(0);
        $promoMsgContainer = $container.find('.l-pdp-promo_message').eq(0);
        $promoMsgPriceContainer = $container.find('.b-product_bottom_price').eq(0);
    } else {
        $container = $('.js-product_content');

        $varGroupInput = $container.find('.l-pdp-bottom_info').eq(0).find('#varGroupPid').eq(0);
        $promoMsgContainer = $container.find('.js-pdp-top_info').find('.l-pdp-promo_message').eq(0);
        $promoMsgPriceContainer = $container.find('.l-pdp-bottom_info').eq(0).find('.b-product_bottom_price').eq(0);
    }

    if (!$varGroupInput.val()) {
        return;
    }

    var params = {
        pid: $varGroupInput.val()
    }

    ajax.load({
        url: util.appendParamsToUrl(window.Urls.getProductPromotionsMsg, params),
        timeoutProgress: 2500,
        callback: function(response) {
            if (!response) {
                return;
            }

            var $parsedResponse = $($.parseHTML(response));
            var $allPromoMsg = $parsedResponse.filter('.b-promo_message');
            if (!$allPromoMsg.length) {
                return;
            }

            if ($promoMsgContainer.length) {
                $promoMsgContainer.empty().html($allPromoMsg);
            }
        }
    });
}

function activeSelectedBraSize() {
    var variantSelector = '';
    var $braSizeDetails = $(variantSelector + ' #bra-size-details');
    var selectedBandSize = $braSizeDetails.data('selected-band-size');
    var selectedCupSize = $braSizeDetails.data('selected-cup-size');

    if (selectedBandSize && selectedCupSize) {
        var $selectedBandSizeBtn = $(variantSelector + ' .js-band-size-button[data-band-size="' + selectedBandSize + '"]');
        var $selectedCupSizeBtn = $(variantSelector + ' .js-cup-size-button[data-cup-size="' + selectedCupSize + '"]');
        var cupSizeAvailability = $selectedBandSizeBtn.data('cup-sizes-availability');

        var braType = (['A','B','C','D'].indexOf(selectedCupSize) > -1 && 'ad') || (['DD','E','F','FF','G'].indexOf(selectedCupSize) > -1 && 'ddg');
        productImages.setSize(braType);

        if (cupSizeAvailability && cupSizeAvailability.split(',').indexOf(selectedCupSize) > -1) {
            // OPTIMIZATION: Batch DOM updates for initial bra size selection
            DOMBatcher.schedule(function() {
                $selectedBandSizeBtn.addClass('active');
                $selectedCupSizeBtn.addClass('active');
            });
        } else {
            clearBraSizeFilters(null, this, variantSelector);
            // Use setTimeout to ensure DOM batch is processed before triggering click
            setTimeout(function() {
                $selectedBandSizeBtn.trigger('click');
            }, 0);
        }
    }
}

function initializeSizeButtons() {
    var $document = $(document);

    $document.on('click', '.js-ab-disabled', function (e) {
        e.preventDefault();
    });
    $document.on('click', '.js-band-size-button:not(".js-ab-disabled")', bandSizeClickHandler);
    $document.on('click', '.js-cup-size-button:not(".js-ab-disabled")', cupSizeClickHandler);

    activeSelectedBraSize();
}

module.exports = {
    init : function(params) {
        if (initialized) {
            return;
        }

        initializeEvents();
        initializeParams(params);
        initializePrefSize(params);
        initializeSizeButtons();
        initializeFirstVariant();
        detailsTabs();

        if (!variantFromPS()) {
            updatePromoMsg();
        }

        initialized = true;
    }
};
